import api from "./client";

export async function listCards(params = {}) {
  const data = await listCardsPaged(params);
  return data.items;
}

export async function listCardsPaged({ type, search, page, limit } = {}) {
  const res = await api.get("/cards", { params: { type, search, page, limit } });
  return res.data.data;
}

export async function createCard(payload) {
  const res = await api.post("/cards", payload);
  return res.data.data;
}

export async function updateCard(id, payload) {
  const res = await api.put(`/cards/${id}`, payload);
  return res.data.data;
}

export async function deleteCard(id) {
  const res = await api.delete(`/cards/${id}`);
  return res.data.data;
}

// Customer Excel import
export async function validateCustomersImport(rows) {
  const res = await api.post("/cards/customers/import/validate", { rows });
  return res.data.data; // { resolved, errors }
}

export async function importCustomers(rows) {
  const res = await api.post("/cards/customers/import", { rows });
  return res.data.data; // { customers_created, customers_updated, ids, errors }
}

// Supplier Excel import
export async function validateSuppliersImport(rows) {
  const res = await api.post("/cards/suppliers/import/validate", { rows });
  return res.data.data; // { resolved, errors }
}

export async function importSuppliers(rows) {
  const res = await api.post("/cards/suppliers/import", { rows });
  return res.data.data; // { suppliers_created, suppliers_updated, ids, errors }
}

